<template>
  <div class="newflowtree">
    <!-- 主流程 -->
    <!-- 开始节点 -->
    <div v-show="tree.stepType == 4 || tree.stepType == 1 || tree.stepType == 3 || tree.stepType == 6" class="start-node-bg">
      <div ref="originList" :class="tree.approvalStatus == 2 ? 'start-node2' : tree.approvalStatus == 1 ? 'start-node1' : 'start-node'" @click="handleEdit(tree)">
        <div>{{ tree.stepType === 3 ? tree.data.form.approvalName :  tree.stepType === 4 ? tree.data.copyName?`抄送：${tree.data.copyName}`:'抄送节点' : tree.title }}<br>{{ tree.userName }}</div>
      </div>
      <div class="add-node">
        <div class="top"></div>
      </div>
      <div class="add-node">
        <div class="bottom"></div>
      </div>
    </div>
    <div v-show="tree.stepType == 5" class="con-node-bg">
      <div class="bottom_all-bg">
        <div class="bottom_all-delete">
          <el-button round class="bottom_all" style="margin: 0;position:relative;z-index:2;">添加条件</el-button>
        </div>
      </div>
      <div class="con-node-hr">
        <div class="item">
          <div v-for="(item, index2) in tree.childNode" :key="index2" class="box">
            <div class="lin-top" :style="index2 == 0 ? topLeft : ''"></div>
            <div class="lin-bottom" :style="index2 == 0 ? bottomLeft : ''"></div>
            <div class="lin-top" :style="index2 + 1 == tree.childNode.length ? topRight : ''"></div>
            <div class="lin-bottom" :style="index2 + 1 == tree.childNode.length ? bottomRight : ''"></div>
            <div class="add-node">
              <div class="bottom" style="height: 40px;"></div>
            </div>
            <div class="add-node">
              <div class="triangle">
                <div class="the-triangle"></div>
              </div>
            </div>
            <!-- 树节点配置 -->
            <div class="box-info" @click="setConditions(item, tree.childNode, index2)">
              <div class="priority-container">{{ item.processApprovalNodeVo?`条件：${item.processApprovalNodeVo.approvalName}`:`优先级${item.priorityNo}` }}</div>
              <div class="conditions-container">{{ item.title }}</div>
            </div>
            <div class="add-node">
              <div class="top" style="height: 20px;"></div>
            </div>
            <div class="add-node">
              <div class="bottom" style="height: 20px;"></div>
            </div>
            <!-- <div class="back-node">

            </div> -->
            <!-- 递归加载 -->
            <template v-for="(list2, index3) in item.childNode">
              <Tree :key="index3" :tree="list2" :index="index3" @func="treeChange"/>
            </template>
          </div>
        </div>
      </div>
      <div class="add-node">
        <div class="top"></div>
      </div>
      <div class="add-node">
        <div class="bottom"></div>
      </div>
      <div class="add-node">
        <div class="triangle">
          <div class="the-triangle"></div>
        </div>
      </div>
    </div>
    <div v-show="tree.stepType == 2" class="circle-bg">
      <div class="circle-bot">
        <div class="circle">
          <div>
            流程
            <br />结束
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { getNodeId } from '@/utils/utils';
import bus from './bus';
export default {
  name: "Tree",
  data() {
    return {
      treeList: [],
      screenWidth: document.body.clientWidth,
      currentNode: ''
    };
  },
  props: ["tree", "index", "fallbackLists", "infoDom",],
  computed: {
    style() {
      return `width:300px`;
    },
    topLeft() {
      return `position: absolute;left: 0;top:-2px;height: 2px;width:calc( 100% / 2 - 1px);background: #fafcff;`;
    },
    bottomLeft() {
      return `position: absolute;left: 0;bottom:-2px;height: 2px;width:calc( 100% / 2 - 1px);background: #fafcff;`;
    },
    topRight() {
      return `position: absolute;right: 0;top:-2px;height: 2px;width:calc( 100% / 2 - 1px);background: #fafcff;`;
    },
    bottomRight() {
      return `position: absolute;right: 0;bottom:-2px;height: 2px;width:calc( 100% / 2 - 1px);background: #fafcff;`;
    },
  },
  methods: {
    /**
     * 配置条件分支
     */
    setConditions(data, parentData) {
      bus.$emit("setConditionEvent", data, parentData);
    },
    /* 
    * 获取节点的位置信息
    */
    originList() {
      // let h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight; //浏览器高度
      let H = this.$refs.originList.offsetHeight;
      let W = this.$refs.originList.offsetWidth;
      let left = this.$refs.originList.offsetLeft;
      let top = this.$refs.originList.offsetTop;
      let current = this.$refs.originList.offsetParent;

      // 一直循环直到根元素
      while(current != null) {
        if(current != null && ((current.childNodes)[0].innerHTML.split(">"))[0] != this.infoDom) {
          left = left + current.offsetLeft;
          top = top + current.offsetTop;
        }
        current = current.offsetParent;
      }
      let obj = {
        id: this.tree.id,
        H:H,
        W:W,
        X:left,
        Y:top,
      }
      // console.log(obj);
      this.$emit('func', obj);
    },
    treeChange(data) {
      this.$emit('func', data);
    }
  },
  mounted() {
    this.originList();

    // 监听窗口变化
    window.onresize = () => (() => {
        window.screenWidth = document.body.clientWidth;
        this.screenWidth = window.screenWidth;
    })();
  },
  watch: {
    screenWidth(val) {
      if (!this.timer) {
        this.screenWidth = val;
        this.timer = true;
        const that = this;
        setTimeout(function () {
          this.originList();
          that.timer = false;
        }, 10);
      }
    }
  }
};
</script>
<style lang="scss" src="./flowMap.scss" scoped></style>
<style lang="scss">
.flowMap {
  .el-dialog {
    margin-top: 65px !important;
  }
}
</style>

